import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const RequestMethodSelection = () => {
    const navigate = useNavigate();
    const { projectid } = useParams();

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#F5F6F8] p-4">
            <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-lg">
                <h2 className="text-center text-2xl font-bold text-[#1B1B1D]">Choose Submission Method</h2>

                <p className="mt-2 text-center text-sm text-gray-500">
                    Select how you want to submit your request
                </p>

                <div className="mt-8 space-y-4">
                    <button
                        onClick={() => navigate(`/serviceportal/${projectid}/multistepform`)}
                        className="w-full rounded-2xl border border-[#D4D4D4] bg-white p-5 text-left shadow-sm transition hover:shadow-md"
                    >
                        <div className="text-lg font-semibold">Fill Details Manually</div>

                        <div className="mt-1 text-sm text-gray-500">
                            Enter your details and request using the form
                        </div>
                    </button>

                    <button
                        onClick={() => navigate(`/serviceportal/${projectid}/voice-request`)}
                        className="w-full rounded-2xl bg-gradient-to-r from-[#6D4DFF] to-[#8A6CFF] p-5 text-left text-white shadow-md"
                    >
                        <div className="text-lg font-semibold">Voice Request</div>

                        <div className="mt-1 text-sm text-white/80">
                            Record your voice and explain your issue directly
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RequestMethodSelection;
